import { useState, useEffect } from 'react'

import { getDistrictsAPI } from '../services/address'

function UseDistricts(id) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getDistrictsAPI(id)
      if (!result) return

      const newData =
        result.result.length > 0 &&
        result.result.map((d, i) => {
          return { value: d.AMPHUR_ID, label: d.AMPHUR_NAME, id: d.AMPHUR_ID }
        })

      setData(newData)
    }
    if (id > 0) {
      getData()
    }
  }, [id])

  return data
}

export default UseDistricts
